export default {
  en: {
    // Product Mix Trend
    'productMixTrend': 'Product Mix Trend',
    'byDate': 'By Date',
    'byStore': 'By Store',

    // RFM Price Comparison
    'rfm-price-comparison': 'RFM Price Comparison',
    'search': 'Search',
    'menu-item-number': 'Menu Item #',
    'menu-price': 'Menu Price',
    'price': 'Price',
    'delivery-price': 'Delivery Price',
    'delivery-price-is-other-price-in-rfm': 'Delivery Price is Other price in RFM',
    'delivery-premium': 'Delivery Premium',
    'indicates-that-delivery-price-is-less': 'indicates that Delivery Price is less than your lower threshold',
    'indicates-that-delivery-price-is-greater': 'indicates that Delivery Price is greater than your upper threshold',
    'delivery': 'Delivery',
    'non-delivery': 'Non-Delivery',
    'combined': 'Combined',
    'point-of-order': 'Point of Order',
    'group': 'Group',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Delivery Premium Thresholds',
    'upper-threshold': 'Upper Threshold',
    'lower-threshold': 'Lower Threshold',
    'close': 'Close',
    'reset': 'Reset',
    'save': 'Save',

    // Delivery Price Index
    'delivery-price-index': 'Delivery Price Index',
    'delivery-premium-desc': '(Delivery price minus Non-delivery price) divided by Non Delivery Price',
    'delivery-price-desc': 'Menu Item price for an item sold in a delivery order',
    'non-delivery-price': 'Non-Delivery Price',
    'non-delivery-price-desc': 'Price of menu item on non-delivery orders (usually matches to RFM EAT IN and TAKE OUT price)',
    'description': 'Description',
    'description-desc': 'Menu Item Description',
    'menu-item-number-desc': 'The Menu Item number',

    // PMIX Discount
    'by-date': 'By Date',
    'pmix-discount': 'PMIX Discount',
    'price-after-offer': 'Price After Offer',
    'total-offer-$': 'Total Offer $',
    'unit-offer-$': 'Unit Offer $',
    'offer-qty': 'Offer Qty',
    'menu-item-description': 'Menu Item Description',
    'offer-name': 'Offer Name',
    'name-of-discount-from-digital-app-or-pos-system': 'Name of Discount from Digital App or POS system',

    // Product Mix (Pmix)
    'four-days-ago': '4 Days Ago',
    'grubhub-warning': 'Grubhub 3PO order accuracy data is not currently available',
    'second-warning': 'Reports receive 3PO McDelivery data 3 days after the business date at 5:45 PM CST. First day available in reports is 4 days prior',
    'product-mix': 'Product Mix',
    'product-mix-analysis': 'Product Mix Analysis',
    'wrap-combo-units-sold-based-off-of': 'Wrap Combo Units Sold are based off the menu item, therefore the 2 wrap menu items will need to be multiplied by 2 to get total single units sold.',
    'live': 'Live',
    'margin': 'Margin',
    'click-to-drill-down-item': 'Click on a menu item or watch list to drill down',
    'click-to-drill-down-location': 'Click on a location to drill down',
    'pmix-by-location': 'By Location',
    'pmix-item-detail': 'Item Detail',

    // Kitchen Capacity
    'kitchen-capacity': 'Kitchen Capacity',

    // Product Outage
    'all-outages': 'All',
    'current-outages': 'Current',
    'outage-type': 'Outage Type',
    'reported-product-outage': 'Reported Product Outage',
    'the-menu-item-number': 'The menu item number',
  },
  es: {
    // Product Mix Trend
    'productMixTrend': 'Tendencia de mezcla de productos',
    'byDate': 'Por fecha',
    'byStore': 'Por tienda',

    // RFM Price Comparison
    'rfm-price-comparison': 'Comparación de precios de RFM',
    'search': 'Buscar',
    'menu-item-number': 'Artículo del Menú #',
    'menu-price': 'Precio del Menú',
    'price': 'Precio',
    'delivery-price': 'Precio de Entrega',
    'delivery-price-is-other-price-in-rfm': 'El precio de entrega es otro precio en RFM',
    'delivery-premium': 'Prima de Entrega',
    'indicates-that-delivery-price-is-less': 'indica que el Precio de Entrega es menos (o menor) que su umbral inferior',
    'indicates-that-delivery-price-is-greater': 'indica que el Precio de Entrega es mas (o mayor) que su umbral superior',
    'delivery': 'Entrega',
    'non-delivery': 'Sin Entrega',
    'combined': 'Combinado',
    'point-of-order': 'Punto de Orden',
    'group': 'Grupo',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Umbrales de prima de entrega',
    'upper-threshold': 'Umbral superior',
    'lower-threshold': 'Umbral inferior',
    'close': 'Cerrar',
    'reset': 'Reiniciar',
    'save': 'Guardar',

    // Delivery Price Index
    'delivery-price-index': 'Índice de Precios de Entrega',
    'delivery-premium-desc': '(Precio de entrega menos precio sin entrega) dividido por precio sin entrega',
    'delivery-price-desc': 'Precio del artículo del menú para un artículo vendido en un pedido de entrega',
    'non-delivery-price': 'Precio sin Entrega',
    'non-delivery-price-desc': 'Precio del artículo del menú en pedidos sin entrega (usualmente coincide con el precio de RFM PARA COMER EN EL LOCAL y PARA LLEVAR)',
    'description': 'Descripción',
    'description-desc': 'Descripción del Artículo del Menú',
    'menu-item-number-desc': 'El número del Artículo del Menú',

    // PMIX Discount
    'by-date': 'Por Fecha',
    'pmix-discount': 'Descuento PMIX',
    'price-after-offer': 'Precio Después de la Oferta',
    'total-offer-$': 'Total de Oferta $',
    'unit-offer-$': 'Unidad de Oferta $',
    'offer-qty': 'Cantidad de Oferta',
    'menu-item-description': 'Descripción del Artículo del Menú',
    'offer-name': 'Nombre de la Oferta',
    'name-of-discount-from-digital-app-or-pos-system': 'Nombre del Descuento de la Aplicación Digital o del Sistema Punto de Venta',

    // Product Mix (Pmix)
    'four-days-ago': 'Hace 4 días',
    'grubhub-warning': 'Los datos de precisión de pedidos de Grubhub 3PO no están disponibles actualmente',
    'second-warning': 'Los informes reciben datos de 3PO McDelivery 3 días después de la fecha comercial a las 5:45 PM CST. El primer día disponible en los informes es 4 días antes',
    'product-mix': 'Mezcla de Productos',
    'product-mix-analysis': 'Análisis de Mezcla de Productos',
    'wrap-combo-units-sold-based-off-of': 'Las unidades vendidas de Wrap Combo se basan en el artículo del menú; por lo tanto, los 2 artículos de Wrap deben multiplicarse por 2 para obtener el total de unidades individuales vendidas.',
    'live': 'En vivo',
    'margin': 'Margen',
    'click-to-drill-down-item': 'Haz clic en un artículo del menú o lista de observación para profundizar',
    'click-to-drill-down-location': 'Haz clic en una ubicación para profundizar',
    'pmix-by-location': 'Por Ubicación',
    'pmix-item-detail': 'Detalle del Artículo',

    // Kitchen Capacity
    'kitchen-capacity': 'Capacidad de Cocina',

    // Product Outage
    'all-outages': 'Todas',
    'current-outages': 'Actuales',
    'outage-type': 'Tipo de Interrupción',
    'reported-product-outage': 'Interrupción de producto reportada',
    'the-menu-item-number': 'El número de artículo del menú',
  },
  fr: {
    // Product Mix Trend
    'productMixTrend': 'Tendance du mix produits',
    'byDate': 'Par date',
    'byStore': 'Par restaurant',

    // RFM Price Comparison
    'rfm-price-comparison': 'Comparaison des prix RFM',
    'search': 'Rechercher',
    'menu-item-number': 'N° d’article du menu',
    'menu-price': 'Prix au menu',
    'price': 'Prix',
    'delivery-price': 'Prix en livraison',
    'delivery-price-is-other-price-in-rfm': 'Le prix en livraison correspond au prix « Autre » dans RFM',
    'delivery-premium': 'Supplément livraison',
    'indicates-that-delivery-price-is-less': 'indique que le prix en livraison est inférieur à votre seuil bas',
    'indicates-that-delivery-price-is-greater': 'indique que le prix en livraison est supérieur à votre seuil haut',
    'delivery': 'Livraison',
    'non-delivery': 'Hors livraison',
    'combined': 'Combiné',
    'point-of-order': 'Point de commande',
    'group': 'Groupe',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Seuils du supplément livraison',
    'upper-threshold': 'Seuil haut',
    'lower-threshold': 'Seuil bas',
    'close': 'Fermer',
    'reset': 'Réinitialiser',
    'save': 'Enregistrer',

    // Delivery Price Index
    'delivery-price-index': 'Indice des prix en livraison',
    'delivery-premium-desc': '(Prix en livraison moins prix hors livraison) divisé par le prix hors livraison',
    'delivery-price-desc': 'Prix de l’article du menu vendu dans une commande en livraison',
    'non-delivery-price': 'Prix hors livraison',
    'non-delivery-price-desc': 'Prix de l’article du menu sur les commandes hors livraison (correspond généralement aux prix RFM SUR PLACE et À EMPORTER)',
    'description': 'Description',
    'description-desc': 'Description de l’article du menu',
    'menu-item-number-desc': 'Le numéro de l’article du menu',

    // PMIX Discount
    'by-date': 'Par date',
    'pmix-discount': 'Remise PMIX',
    'price-after-offer': 'Prix après offre',
    'total-offer-$': 'Total offre $',
    'unit-offer-$': 'Offre unitaire $',
    'offer-qty': 'Qté offre',
    'menu-item-description': 'Description de l’article du menu',
    'offer-name': 'Nom de l’offre',
    'name-of-discount-from-digital-app-or-pos-system': 'Nom de la remise provenant de l’application mobile ou du système de caisse',

    // Product Mix (Pmix)
    'four-days-ago': 'Il y a 4 jours',
    'grubhub-warning': 'Les données de précision des commandes Grubhub 3PO ne sont pas disponibles actuellement',
    'second-warning': 'Les rapports reçoivent les données McDelivery 3PO 3 jours après la date d’activité, à 17 h 45 CST. Le premier jour disponible dans les rapports remonte à 4 jours',
    'product-mix': 'Mix produits',
    'product-mix-analysis': 'Analyse du mix produits',
    'wrap-combo-units-sold-based-off-of': 'Les unités vendues de Wrap Combo sont calculées à partir de l’article du menu ; les 2 articles Wrap doivent donc être multipliés par 2 pour obtenir le total des unités vendues à l’unité.',
    'live': 'En direct',
    'margin': 'Marge',
    'click-to-drill-down-item': 'Cliquez sur un article du menu ou une liste de suivi pour explorer en détail',
    'click-to-drill-down-location': 'Cliquez sur un site pour explorer en détail',
    'pmix-by-location': 'Par Site',
    'pmix-item-detail': "Détail de l'Article",

    // Kitchen Capacity
    'kitchen-capacity': 'Capacité de la cuisine',

    // Product Outage
    'all-outages': 'Toutes',
    'current-outages': 'En cours',
    'outage-type': 'Type de rupture',
    'reported-product-outage': 'Rupture de produit signalée',
    'the-menu-item-number': 'Le numéro de l’article du menu',
  },
  'fr-ca': {
    // Product Mix Trend
    'productMixTrend': 'Tendance de la répartition des produits',
    'byDate': 'Par date',
    'byStore': 'Par restaurant',

    // RFM Price Comparison
    'rfm-price-comparison': 'Comparaison des prix RFM',
    'search': 'Rechercher',
    'menu-item-number': 'N° d’article du menu',
    'menu-price': 'Prix au menu',
    'price': 'Prix',
    'delivery-price': 'Prix en livraison',
    'delivery-price-is-other-price-in-rfm': 'Le prix en livraison correspond au prix « Autre » dans RFM',
    'delivery-premium': 'Supplément de livraison',
    'indicates-that-delivery-price-is-less': 'indique que le prix en livraison est inférieur à votre seuil inférieur',
    'indicates-that-delivery-price-is-greater': 'indique que le prix en livraison est supérieur à votre seuil supérieur',
    'delivery': 'Livraison',
    'non-delivery': 'Hors livraison',
    'combined': 'Combiné',
    'point-of-order': 'Point de commande',
    'group': 'Groupe',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Seuils du supplément de livraison',
    'upper-threshold': 'Seuil supérieur',
    'lower-threshold': 'Seuil inférieur',
    'close': 'Fermer',
    'reset': 'Réinitialiser',
    'save': 'Enregistrer',

    // Delivery Price Index
    'delivery-price-index': 'Indice des prix en livraison',
    'delivery-premium-desc': '(Prix en livraison moins prix hors livraison) divisé par le prix hors livraison',
    'delivery-price-desc': 'Prix de l’article du menu vendu dans une commande en livraison',
    'non-delivery-price': 'Prix hors livraison',
    'non-delivery-price-desc': 'Prix de l’article du menu sur les commandes hors livraison (correspond habituellement aux prix RFM POUR MANGER SUR PLACE et POUR EMPORTER)',
    'description': 'Description',
    'description-desc': 'Description de l’article du menu',
    'menu-item-number-desc': 'Le numéro de l’article du menu',

    // PMIX Discount
    'by-date': 'Par date',
    'pmix-discount': 'Rabais PMIX',
    'price-after-offer': 'Prix après l’offre',
    'total-offer-$': 'Total de l’offre $',
    'unit-offer-$': 'Offre unitaire $',
    'offer-qty': 'Qté de l’offre',
    'menu-item-description': 'Description de l’article du menu',
    'offer-name': 'Nom de l’offre',
    'name-of-discount-from-digital-app-or-pos-system': 'Nom du rabais provenant de l’application mobile ou du système PDV',

    // Product Mix (Pmix)
    'four-days-ago': 'Il y a 4 jours',
    'grubhub-warning': 'Les données d’exactitude des commandes Grubhub 3PO ne sont pas disponibles pour le moment',
    'second-warning': 'Les rapports reçoivent les données McDelivery 3PO 3 jours après la date d’exploitation, à 17 h 45 HNC. Le premier jour disponible dans les rapports remonte à 4 jours',
    'product-mix': 'Répartition des produits',
    'product-mix-analysis': 'Analyse de la répartition des produits',
    'wrap-combo-units-sold-based-off-of': 'Les unités vendues de Wrap Combo sont établies à partir de l’article du menu; les 2 articles Wrap doivent donc être multipliés par 2 pour obtenir le total des unités vendues à l’unité.',
    'live': 'En direct',
    'margin': 'Marge',
    'click-to-drill-down-item': 'Cliquez sur un article du menu ou une liste de suivi pour afficher le détail',
    'click-to-drill-down-location': 'Cliquez sur un emplacement pour afficher le détail',
    'pmix-by-location': 'Par Emplacement',
    'pmix-item-detail': "Détail de l'Article",

    // Kitchen Capacity
    'kitchen-capacity': 'Capacité de la cuisine',

    // Product Outage
    'all-outages': 'Toutes',
    'current-outages': 'En cours',
    'outage-type': 'Type de rupture',
    'reported-product-outage': 'Rupture de produit signalée',
    'the-menu-item-number': 'Le numéro de l’article du menu',
  },
};